import { Component, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { AIJobsDescriptionComponent } from '../ai-jobs-description/ai-jobs-description.component';
import { IUserJob } from '../core/IUserJob';


@Component({
    selector: 'ai-jobs-wrapper',
    templateUrl: 'ai-jobs-wrapper.component.html',
    styleUrls: ['ai-jobs-wrapper.component.scss']
})
export class AIJobsWrapperComponent implements OnChanges{

    @Input() userJobs: Array<IUserJob>=[];
    @Output() resetEmit = new EventEmitter();
    public currentUserJob: IUserJob;

    constructor() { }

    ngOnChanges() {
      if (this.currentUserJob) {
        for (let i = 0; i < this.userJobs.length; i++) {
          if(this.userJobs[i].guid === this.currentUserJob.guid) {
              this.currentUserJob = this.userJobs[i];
          }
        }
      }     
    }

    setUserJob(userJob: IUserJob) {
        for (let i = 0; i < this.userJobs.length; i++) {
            if(this.userJobs[i].guid === userJob.guid) {
                this.userJobs[i] = userJob;
                this.currentUserJob = userJob;
            }
        }
    }

    reset () {
      this.resetEmit.emit();
    }

    setCurrentJob($event) {      
      this.currentUserJob = $event;
    }
}
